module.exports = require("react-dates/initialize");